'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$5() {
  this.bkh = null;
  this.bkf = null;
  this.bkg = false;
  this.bkd = null;
  this.bke = false;
  this.bki = false;
  this.bkj = false;
  this.bkh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$5 as $c_Lpresto_PrestoRouter$$anon$5 };
$p = $c_Lpresto_PrestoRouter$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$5;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$5() {
}
export { $h_Lpresto_PrestoRouter$$anon$5 as $h_Lpresto_PrestoRouter$$anon$5 };
$h_Lpresto_PrestoRouter$$anon$5.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bkh;
});
$p.t = (function() {
  if ((!this.bkg)) {
    this.bkf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkg = true;
  }
  return this.bkf;
});
$p.ag = (function() {
  if ((!this.bke)) {
    this.bkd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bke = true;
  }
  return this.bkd;
});
$p.v = (function() {
  if ((!this.bkj)) {
    this.bki = false;
    this.bkj = true;
  }
  return this.bki;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$5, "presto.PrestoRouter$$anon$5", ({
  Op: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$5 as $d_Lpresto_PrestoRouter$$anon$5 };
//# sourceMappingURL=presto.-Presto-Router$$anon$5.js.map
